import React, { ReactElement } from 'react';
import styled from 'styled-components';
import Button from '@components/shared/Button';
import Colors from '@components/shared/Colors';
import { TextWithButtonData } from '@contracts';

interface Props {
  data: TextWithButtonData;
  button?: ReactElement;
  price?: string;
}

const TextWithButtonBox: React.FC<Props> = ({ data, button, price = '' }) => {
  const formattedPrice = ` ${price}`;
  return (
    <Container>
      <Description dangerouslySetInnerHTML={{ __html: data.description + formattedPrice }} />
      <ButtonWrap>
        {button || (
          <ButtonStyled onClick={data.onClick} $backgroundColor="transparent">
            {data.buttonText}
          </ButtonStyled>
        )}
      </ButtonWrap>
    </Container>
  );
};

export default TextWithButtonBox;

const Container = styled.div`
  border: 1px solid #f9d07c;
  background: #fffbe7;
  column-gap: 20px;
  margin: 10px 0;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1220px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
    text-align: center;
  }

  @media (max-width: 1024px) {
    padding: 20px;
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
`;

const Description = styled.div`
  max-width: 255px;
  font-family: BrownStd;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  text-align: left;

  @media (max-width: 1220px) {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    text-align: center;
  }
`;

const ButtonWrap = styled.div`
  width: 170px;
  height: 50px;
  & button {
    width: 100%;
  }
  @media (max-width: 1220px) {
    width: 100%;
  }

  @media (max-width: 1024px) {
    margin-top: 20px;
  }
`;

interface ButtonStyledProps {
  $backgroundColor: string;
}

const ButtonStyled = styled(Button)<ButtonStyledProps>`
  all: unset;
  cursor: pointer;
  transition: all 0.2s ease;

  color: ${Colors.cream};
  width: 100%;
  height: 100%;
  background: ${(props) => props.$backgroundColor};
  border-radius: 2px;

  font-family: BrownStd;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 768px) {
    padding: 0;
  }
`;
